import { connect } from 'react-redux'

import {
  resetAllFilters,
  filterType,
  filterBedrooms,
  filterBudget,
  showAllFilters,
} from '../redux/modules/search/actions'

import FilterButtons from '../components/FilterButtons'

const actionsCreators = {
  resetAllFilters,
  filterType,
  filterBedrooms,
  filterBudget,
  showAllFilters,
}

export default connect(null, actionsCreators)(FilterButtons)



// WEBPACK FOOTER //
// ./src/containers/FilterButtons.js